import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

import MainLayout from '../components/Layout/MainLayout';
import AiDiagnosisPanelV2 from '../components/Board/AiDiagnosisPanelV2';
import type { DiagnosisId } from '../types/llm-diagnosis';
import { useUser } from '../contexts/UserContext';

const BoardV2: React.FC = () => {
  const { user, loading } = useUser();
  const [activeDiagnosisId, setActiveDiagnosisId] = useState<DiagnosisId | null>(null);

  if (loading) return null;
  if (!user || !user.is_admin) return <Navigate to="/board" replace />;

  return (
    <MainLayout fullBleed>
      <AiDiagnosisPanelV2
        activeDiagnosisId={activeDiagnosisId}
        setActiveDiagnosisId={setActiveDiagnosisId}
      />
    </MainLayout>
  );
};

export default BoardV2;
